// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class UserResource extends Resource {
    basePath: string = 'authorisation/user_context/';

    objectPath: string = 'authorisation/user_context/{ident}/';
}
